const CheckPropertyEyeIcon = props => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 12.7562C12.7242 12.7562 15.8844 10.3443 17 6.99992C15.8844 3.65558 12.7242 1.24365 9 1.24365C5.27581 1.24365 2.11564 3.65558 1 6.99992C2.11659 10.3443 5.27581 12.7562 9 12.7562Z"
      stroke="#0D0D0D"
      strokeWidth="1.09754"
      strokeMiterlimit="10"
    />
    <path
      d="M8.9827 9.44098C10.3269 9.44098 11.4166 8.3513 11.4166 7.00711C11.4166 5.66292 10.3269 4.57324 8.9827 4.57324C7.63851 4.57324 6.54883 5.66292 6.54883 7.00711C6.54883 8.3513 7.63851 9.44098 8.9827 9.44098Z"
      stroke="#0D0D0D"
      strokeWidth="1.09754"
      strokeMiterlimit="10"
    />
  </svg>
);

export default CheckPropertyEyeIcon;
